import gql from 'graphql-tag';

export const GET_PLAN_LIST = gql`
    query(
        $golf_group_code: String!
        $golf_code: String
        $plan_name: String
        $plan_member_class: [String]
        $share_flag: Int
        $request_flag: Int
        $limit: Int
        $offset: Int
    ){
        getPlanListFromAdmin(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            plan_name: $plan_name
            plan_member_class: $plan_member_class
            share_flag: $share_flag
            request_flag: $request_flag
            limit: $limit
            offset: $offset
        ) {
            PlanList{
                plan_id
                plan_name
                display_priority
            }
            count
        }
    }
`;

export const REGIST_PLAN_MASTER = gql`
    mutation(
        $golf_group_code: String!
        $golf_code: String!
        ){
        registPlanMaster(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
        ) {
            result
            planId
        }
    }
`;

export const UPDATE_PLAN_MASTER = gql`
    mutation ( $planMasterInput: planMasterInput ){
        updatePlanMaster( input: $planMasterInput ) { result }
    }
`;

export const DELETE_PLAN_MASTER = gql`
    mutation($plan_id: ID!){
    deletePlanMaster(
        plan_id: $plan_id
    ){
        result
    }
    }
`;

export const COPY_PLAN_MASTER = gql`
    mutation($plan_id: Int!){
        copyPlanMaster(plan_id: $plan_id){
            result
        }
    }
`;

export const GET_PLAN_BENEFIT_LIST = gql`
    query($plan_id: Int, $limit: Int, $offset: Int){
        getBenefitList(plan_id: $plan_id, limit: $limit, offset: $offset) {
            PlanBenefitList{
                plan_id
                benefit_cd
                benefit_name
            }
            count
        }
    }
`;

export const GET_PLAN_MASTER = gql`
    query($plan_id: Int){
        getPlanMaster(plan_id: $plan_id){
            golf_code
            plan_name
            plan_member_class
            closing_days
            closing_time
            cancel_policy
            cancel_valid_days
            cancel_valid_time
            share_flag
            share_confirm_days
            share_confirm_time
            request_flag
            request_approval
            player_min
            player_max
            guarantee_code
            round_code
            through_flag
            cart_code
            caddie_flag
            lesson_flag
            meal_flag
            accommodation_flag
            competition_flag
            benefit_flag
            detail
            add_fee_2b_weekday
            add_fee_3b_weekday
            add_fee_2b_weekend
            add_fee_3b_weekend
            plan_fee_min
            plan_fee_max
            plan_start
            plan_valid
            release_start
            release_valid
            display_priority
            times_count
            fees_count
            benefits_count
        }
    }
`;

export const GET_PLAN_BENEFIT = gql`
    query($golf_group_code: String, $golf_code: String){
        getBenefit(golf_group_code: $golf_group_code, golf_code: $golf_code){
            PlanBenefitList{
                benefit_cd
                benefit_name
            }
        }
    }
`;

export const GET_PLAN_FEE_LIST = gql`
    query(
        $plan_id: String!
        $limit: Int
        $offset: Int
    ){
    getPlanFeeList(
        plan_id: $plan_id
        limit: $limit
        offset: $offset
    ){
        PlanFeeList{
            fee_id
            total_fee
            base_fee
            tax_sales
            tax_usage
            tax_others
        }
        count
    }
}
`;

export const GET_FEE_LIST = gql`
    query(
        $plan_id: String!
    ){
    getFeeList(
        plan_id: $plan_id
    ){
        PlanFeeList{
            fee_id
            total_fee
        }
    }
}
`;

export const GET_TAX = gql`
    query(
        $golf_group_code: String
        $golf_code: String
        $tax_id: String
        $start_date: String
    ){
    getPlanTax(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        tax_id: $tax_id
        start_date: $start_date
    ){
        tax_id
        tax_name
        tax_array
    }
}`;

export const REGIST_PLAN_FEE = gql`
    mutation(
        $plan_id: ID!
        $total_fee: Int!
        $base_fee: Int!
        $tax_sales: Int!
        $tax_usage: Int!
        $tax_others: Int!
    ){
    registPlanFee(
        plan_id: $plan_id
        total_fee: $total_fee
        base_fee: $base_fee
        tax_sales: $tax_sales
        tax_usage: $tax_usage
        tax_others: $tax_others
    ){
        result
    }
}`;

export const UPDATE_PLAN_FEE = gql`
    mutation(
        $fee_id: ID!
        $plan_id: Int!
        $total_fee: Int!
        $base_fee: Int!
        $tax_sales: Int!
        $tax_usage: Int!
        $tax_others: Int!
    ){
    updatePlanFee(
        fee_id: $fee_id
        plan_id: $plan_id
        total_fee: $total_fee
        base_fee: $base_fee
        tax_sales: $tax_sales
        tax_usage: $tax_usage
        tax_others: $tax_others
    ){
        result
    }
}`;

export const DELETE_PLAN_FEE = gql`
    mutation(
    $fee_id: ID!
    ){
    deletePlanFee(
        fee_id: $fee_id
    ){
        result
    }
}`;

export const GET_PLAN_TIME_LIST = gql`
    query($plan_id: String!, $limit: Int!,$offset: Int!){
    getPlanTimeList(
        plan_id: $plan_id, limit: $limit, offset: $offset
    ){
        PlanTimeList{
            course_name
            course_code
            play_start
            play_end
        }
        count
        }
    }
`;

export const REGIST_PLAN_TIME = gql`
    mutation($plan_id: ID!, $golf_group_code: String!, $golf_code: String!, $course_code: Int!, $play_start: String!, $play_end: String!){
        registPlanTime(
            plan_id: $plan_id
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            course_code: $course_code
            play_start: $play_start
            play_end: $play_end
        ){
            result
        }
    }
`;

export const DELETE_PLAN_TIME = gql`
    mutation(
        $plan_id: ID!
        $golf_group_code: String!
        $golf_code: String!
        $course_code: Int!
        $play_start: String!
        $play_end: String!
    ){
        deletePlanTime(
            plan_id: $plan_id
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            course_code: $course_code
            play_start: $play_start
            play_end: $play_end
        ){
            result
        }
    }
`;

export const GET_GOLF_COURSE = gql`
    query($golf_group_code: String!, $golf_code: String){
        getGolfCourse(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
    ){
        golf_code
        golf_name
    }
}
`;

export const GET_COURSE_LIST = gql`

query($golf_group_code: String!, $golf_code: String!)
    {
    GetCoursesList(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
    ){
        course_code
        course_name
    }
}
`;

export const REGIST_PLAN_BENEFIT = gql`
    mutation($plan_id: Int!, $benefit_cd: Int!){
        registPlanBenefit(
            plan_id: $plan_id,
            benefit_cd: $benefit_cd
        ) {
            result
        }
    }
`;

export const DELETE_PLAN_BENEFIT = gql`
    mutation($plan_id: Int!, $benefit_cd: Int!){
        deletePlanBenefit(
            plan_id: $plan_id,
            benefit_cd: $benefit_cd
        ) {
            result
        }
    }
`;

export const GET_PLAN_CELL = gql`
    query(
        $plan_id: ID!
        $date: String!
    ){
        getPlanCell(
            plan_id: $plan_id
            date: $date
        ){
            total_fee
            course_name
            course_code
            fee_id
            days{
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
        }
    }
`;

export const UPDATE_FEE_IDS_TO_PLAN_CELLS = gql`
    mutation($dateCells: [dateCells]){
    UpdateFeeIDToPlanCell(
        dateCells: $dateCells
    ){
        result
    }
}
`;

export const GET_RELEASE_FLAG_FROM_PLAN_CELLS = gql`

    query(
        $golf_group_code: String!
        $golf_code: String!
        $plan_id: String!
        $course_code: Int!
        $year: String!
        $month: String!
    ){
        getReleaseFlag(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            plan_id: $plan_id
            course_code: $course_code
            year: $year
            month: $month
        ){
            play_start
            course_code
            days{
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
        }
    }
`;

export const GET_COUNT_FROM_CELL_INFOS = gql`
    query(
    $golf_group_code: String!
    $golf_code: String!
    $plan_id: String!
    $course_code: Int!
    $year: String!
    $month: String!
    ){
    getCountFromCellInfos(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        plan_id: $plan_id
        course_code: $course_code
        year: $year
        month: $month
    )
}
`;

export const UPDATE_RELEASE_FLAG = gql`
    mutation($releaseInput: [releaseInput]){
    UpdateReleaseFlagToCellInfos(
        releaseInput: $releaseInput
    ){
        result
    }
}
`;

export const GET_PLAN_CELL_LIST = gql`
    query(
    $golf_group_code: String!
    $golf_code: String!
    $member_no: String
    $play_date_from: String
    $play_date_to: String
    $cell_number: String
    $price_min_code: String
    $price_max_code: String
    $start_times_codes: [String]
    $style_codes: [String]
    $benefit_codes: [String]
    ){
    getPlanCellList(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        member_no: $member_no
        play_date_from: $play_date_from
        play_date_to: $play_date_to
        cell_number: $cell_number
        price_min_code: $price_min_code
        price_max_code: $price_max_code
        start_times_codes: $start_times_codes
        style_codes: $style_codes
        benefit_codes: $benefit_codes
    ) {
        PlanCellList{
        plan_id
        golf_code
        plan_name
        plan_member_class
        share_flag
        share_confirm_days
        share_confirm_time
        request_flag
        guarantee_code
        round_code
        through_flag
        competition_flag
        cart_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        plan_fee_min
        plan_fee_max
        display_priority
        total_fee
        play_date
        reserve_status
        player_left
        cart_code_icon
        guarantee_code_icon
        round_code_icon
        meal_flag_icon
        caddie_flag_icon
        accommodation_flag_icon
        }
    }
}`;

export const GET_PLAN_INF = gql`
  query(
    $golf_group_code: String!
    $golf_code: String!
    $plan_id: ID!
  ) {
    getPlanInf(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      plan_id: $plan_id
    ) {
      PlanInfList{
        plan_id
        golf_code
        plan_name
        plan_member_class
        closing_days
        closing_time
        cancel_policy
        cancel_valid_days
        cancel_valid_time
        share_flag
        share_confirm_days
        share_confirm_time
        request_flag
        player_min
        player_max
        guarantee_code
        round_code
        through_flag
        competition_flag
        cart_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        detail
        plan_fee_min
        plan_fee_max
        plan_start
        plan_valid
        release_start
        release_valid
        display_priority
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        tax_usage
        tax_others
        meal_flag_name
        caddie_flag_name
        cart_code_name
        guarantee_code_name
        round_code_name
      }
    }
  }
`;

export const GET_PLAN_INF_FROM_ADMIN = gql`
  query(
    $golf_group_code: String!
    $golf_code: String!
    $plan_id: ID!
    $play_date: String!
  ) {
    getPlanInfFromAdmin(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      plan_id: $plan_id
      play_date: $play_date
    ) {
      PlanInfList{
        plan_id
        golf_code
        plan_name
        plan_member_class
        closing_days
        closing_time
        cancel_policy
        cancel_valid_days
        cancel_valid_time
        share_flag
        share_confirm_days
        share_confirm_time
        request_flag
        player_min
        player_max
        guarantee_code
        round_code
        through_flag
        competition_flag
        cart_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        detail
        plan_fee_min
        plan_fee_max
        plan_start
        plan_valid
        release_start
        release_valid
        display_priority
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        total_fee
        base_fee
        tax_sales
        tax_usage
        tax_others
        meal_flag_name
        caddie_flag_name
        cart_code_name
        guarantee_code_name
        round_code_name
      }
    }
  }
`;

// プランに対するスタート時間を取得(予約スタート時間選択用)
export const GET_PLAN_START_TIME_LIST = gql`
  query(
    $plan_id: String!
    $play_date: String!
    $reserve_no: String
  ) {
    getPlanStartTimeList(
      plan_id: $plan_id
      play_date: $play_date
      reserve_no: $reserve_no
    ) {
      StartTimeList{
        cell_id
        plan_id
        course_code
        play_date
        play_start
        reserve_status
        player_left
        course_name
        player_min
        player_max
        reserve_no
      }
    }
  }
`;

// プラン及び枠の情報を取得
export const GET_PLAN_CELL_INF = gql`
  query(
    $plan_id: String!
    $play_date: String
  ) {
    getPlanCellInf(
      plan_id: $plan_id
      play_date: $play_date
    ) {
        plan_id
        plan_name
        detail
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        closing_days
        closing_time
        golf_name
        total_fee
        cancel_detail
        cart_code_icon
        guarantee_code_icon
        round_code_icon
        meal_flag_icon
        caddie_flag_icon
        accommodation_flag_icon
        share_flag_icon
    }
  }
`;
